
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M755.38-315.85L710-362.46q40.38-11 65.19-43.27Q800-438 800-480q0-50.38-35.38-85.96-35.39-35.58-85.39-35.58H526.92v-60h152.31q74.92 0 127.85 53.12Q860-555.31 860-480q0 53.15-28.54 97.11-28.54 43.97-76.08 67.04zM623.23-450l-60-60h66v60h-6zM805.85-69.85l-736-736L112-848l736 736-42.15 42.15zM433.08-298.46H281.54q-75.31 0-128.42-53.12Q100-404.69 100-480q0-66.69 42.96-117.04 42.96-50.34 107.81-60.8H260l56.31 56.3h-34.77q-50.39 0-85.96 35.58Q160-530.38 160-480q0 50.38 35.58 85.96 35.57 35.58 85.96 35.58h151.54v60zM330.77-450v-60h77.69l59 60H330.77z"}})])
          )
        }
      }
    